import * as Yup from 'yup';
import { IntlShape } from 'react-intl';

import { tagFormikValuesFieldNames } from '../models/tag-formik-values';

export const tagsValidationSchema = (intl: IntlShape) => {
    return Yup.object().shape({
        [tagFormikValuesFieldNames.name]: Yup.string().required('app.error.required'),
        [tagFormikValuesFieldNames.description]: Yup.string().max(255, v =>
            intl.formatMessage({ id: 'app.error.maxLength' }, { value: v.max })
        ),
    });
};
